import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=b39c1020&scoped=true&"
import script from "./Loader.vue?vue&type=script&lang=js&"
export * from "./Loader.vue?vue&type=script&lang=js&"
import style0 from "./Loader.vue?vue&type=style&index=0&id=b39c1020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39c1020",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jin_macintosh/Documents/www.nosync/yusuugaku/web/public/wp-content/themes/ysk/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b39c1020')) {
      api.createRecord('b39c1020', component.options)
    } else {
      api.reload('b39c1020', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=b39c1020&scoped=true&", function () {
      api.rerender('b39c1020', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/partials/Loader.vue"
export default component.exports